'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionCountModel', function ($rootScope,
                                              ModelFactory,
                                              TransactionsModel,
                                              SearchModel,
                                              TransactionFilterService) {

    var transactionCountModel = ModelFactory.create(
      'TransactionCountModel', [
        'all',
        'needsReceipt',
        'notReviewed',
        'needsSubmission',
        'needsCardManagerApproval',
        'needsBcaManagerApproval',
        'needsAccountingManagerApproval',
        'searchResults',
        'unlinked',
        'notExtracted'
      ]);
    transactionCountModel.all(0);
    transactionCountModel.needsReceipt(0);
    transactionCountModel.notReviewed(0);
    transactionCountModel.needsSubmission(0);
    transactionCountModel.needsCardManagerApproval(0);
    transactionCountModel.needsBcaManagerApproval(0);
    transactionCountModel.needsAccountingManagerApproval(0);
    transactionCountModel.searchResults(0);
    transactionCountModel.unlinked(0);
    transactionCountModel.notExtracted(0);

    TransactionsModel.onTransactionsChanged($rootScope, refreshCounts);
    SearchModel.onResultsChanged($rootScope, getCountOfSearchResults);

    function refresh(filterName) {
      var filter = TransactionFilterService[ filterName ];
      var count = 0;

      _.forEach(TransactionsModel.transactions(), function(transaction) {
        if (filter(transaction)) {
          count += 1;
        }
      });

      transactionCountModel[ filterName ](count);
      return count;
    }

    function getCountOfAllTransactions() {
      var count = TransactionsModel.transactions().length;
      transactionCountModel.all(count);
      return count;
    }

    function getCountOfTransactionsNeedingReceipt() {
      return refresh('needsReceipt');
    }

    function getCountOfTransactionsNeedingReview() {
      return refresh('notReviewed');
    }

    function getCountOfTransactionsNeedingSubmission() {
      return refresh('needsSubmission');
    }

    function getCountOfTransactionsNeedingCardManagerApproval() {
      return refresh('needsCardManagerApproval');
    }

    function getCountOfTransactionsNeedingBcaManagerApproval() {
      return refresh('needsBcaManagerApproval');
    }

    function getCountOfTransactionsNeedingAccountingManagerApproval() {
      return refresh('needsAccountingManagerApproval');
    }

    function getCountOfSearchResults() {
      return refresh('searchResults');
    }

    function getCountOfTransactionsUnlinked() {
      return refresh('unlinked');
    }

    function getCountOfTransactionsNotExtracted() {
      return refresh('notExtracted');
    }

    return transactionCountModel;

    function refreshCounts() {
      getCountOfAllTransactions();
      getCountOfTransactionsNeedingReceipt();
      getCountOfTransactionsNeedingReview();
      getCountOfTransactionsNeedingSubmission();
      getCountOfTransactionsNeedingCardManagerApproval();
      getCountOfTransactionsNeedingBcaManagerApproval();
      getCountOfTransactionsNeedingAccountingManagerApproval();
      getCountOfTransactionsUnlinked();
      getCountOfTransactionsNotExtracted();
      getCountOfSearchResults();
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/TransactionCountModel.js
// module id = 589
// module chunks = 0